import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const GoogleShoppingGate = React.lazy(() => import("./GoogleShopping.gate"));

const GoogleShoppingLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <GoogleShoppingGate />
  </React.Suspense>
);
export default () => <GoogleShoppingLoadable />;
